module.exports = __webpack_public_path__ + "img/header.4724b301.png";